import React from 'react';

import { ButtonGroup } from '~/eds/src/components/ButtonGroup/ButtonGroup';
import { LayoutType } from '~/enums/LayoutType';
import { useIntl } from 'react-intl';

const { ThreeColumn, TwoColumn } = LayoutType;

export const ColumnLayoutButtonGroup = ({ onChange, layout }) => {
  const intl = useIntl();
  return (
    <ButtonGroup
      actions={[
        {
          icon: 'mosaic',
          id: `button_group_${TwoColumn}`,
          tooltip: intl.formatMessage({
            id: 'ColumnLayoutButtonGroup.twoColumns',
            defaultMessage: '2 columns',
            description: 'Tooltip for two column layout button',
          }),
          onClick: () => onChange(TwoColumn),
          status: layout === TwoColumn ? 'active' : 'default',
        },
        {
          icon: 'panels',
          id: `button_group_${ThreeColumn}`,
          tooltip: intl.formatMessage({
            id: 'ColumnLayoutButtonGroup.threeColumns',
            defaultMessage: '3 columns',
            description: 'Tooltip for three column layout button',
          }),
          onClick: () => onChange(ThreeColumn),
          status: layout === ThreeColumn ? 'active' : 'default',
        },
      ]}
    />
  );
};
